import {Card, Tab, TabPane} from '@binance/uikit'
import {SETTING} from 'constants'
import LimitFormContainer from './LimitFormContainer'
import MarketFormContainer from './MarketFormContainer'
import StopLimitFormContainer from './StopLimitFormContainer'
import TakeProfitFormContainer from './TakeProfitFormContainer'
import TransferBtn from '../Common/TransferBtn'
import FeeBtn from '../Common/FeeBtn'

function OrderFormView ({i18n}) {
  return (
    <Card gridArea="orderform">
      <Tab width="100%" overflow="hidden">
        <TabPane flexDirection="column" label={i18n.limit || 'Limit'}>
          <LimitFormContainer i18n={i18n} />
        </TabPane>
        <TabPane flexDirection="column" label={i18n.market || 'Market'}>
          <MarketFormContainer i18n={i18n} />
        </TabPane>
        <TabPane flexDirection="column" label={i18n.stopLimit || 'Stop-Limit'}>
          <StopLimitFormContainer i18n={i18n} />
        </TabPane>
        {SETTING.enableTakeProfit && (
          <TabPane flexDirection="column" label={i18n.takeProfit || 'Take-Profit-Limit'}>
            <TakeProfitFormContainer i18n={i18n} />
          </TabPane>
        )}
      </Tab>
      <FeeBtn i18n={i18n} />
      <TransferBtn i18n={i18n} style={{position: 'absolute', top: '12px', right: '8px'}} />
    </Card>
  )
}

export default OrderFormView
